export const attrs_input__console = {
    dense: true,
    outlined: true,
    hideDetails: "auto",
    persistentPlaceholder: true,
};

export const attrs_switch__console = {
    inset: true,
    hideDetails: "auto",
    class: "pa-0 ma-0 d-inline-block mr-n2",
};

export const attrs_input = {
    dense: true,
    outlined: true,
    hideDetails: true,
    persistentPlaceholder: true,
};

export const attrs_table = {
    "disable-sort": true,
    "disable-pagination": true,
    "hide-default-footer": true,
};

//  Client attrs
export const attrs_tabs_common = {
    grow: true,
    "hide-slider": true,
    "show-arrows": true,
};
export const attrs_controls_common = {
    "hide-details": "auto",
};
export const attrs_input_common = {
    "hide-details": "auto",
};
export const attrs_file_input_common = {
    "hide-details": "auto",
};
export const attrs_select_common = {
    "hide-details": "auto",
    "menu-props": { contentClass: "v-select-menu" },
};
export const attrs_tooltip_common = {
    bottom: true,
};
